import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const ReviewsPage = lazy(() => import('../pages/reviews/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ArticlePage = lazy(() => import('../pages/blog/article-page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const AffiliateDisclosurePage = lazy(() => import('../pages/affiliate-disclosure/page'));
const RoomInspirationPage = lazy(() => import('../pages/room-inspiration/page'));
const LivingRoomPage = lazy(() => import('../pages/living-room/page'));
const BedroomPage = lazy(() => import('../pages/bedroom/page'));
const KitchenPage = lazy(() => import('../pages/kitchen/page'));
const BathroomPage = lazy(() => import('../pages/bathroom/page'));
const VanitiesPage = lazy(() => import('../pages/bathroom/vanities/page'));
const MirrorsPage = lazy(() => import('../pages/bathroom/mirrors/page'));
const BathroomStoragePage = lazy(() => import('../pages/bathroom/storage/page'));
const AccessoriesPage = lazy(() => import('../pages/bathroom/accessories/page'));
const HomeOfficePage = lazy(() => import('../pages/home-office/page'));
const DesksPage = lazy(() => import('../pages/home-office/desks/page'));
const OfficeChairsPage = lazy(() => import('../pages/home-office/office-chairs/page'));
const OfficeStoragePage = lazy(() => import('../pages/home-office/storage/page'));
const OfficeLightingPage = lazy(() => import('../pages/home-office/lighting/page'));
const DiningRoomPage = lazy(() => import('../pages/dining-room/page'));
const DiningTablesPage = lazy(() => import('../pages/dining-room/dining-tables/page'));
const DiningChairsPage = lazy(() => import('../pages/dining-room/dining-chairs/page'));
const BuffetsPage = lazy(() => import('../pages/dining-room/buffets/page'));
const DiningLightingPage = lazy(() => import('../pages/dining-room/lighting/page'));
const OutdoorPage = lazy(() => import('../pages/outdoor/page'));
const PatioFurniturePage = lazy(() => import('../pages/outdoor/patio-furniture/page'));
const PlantersPage = lazy(() => import('../pages/outdoor/planters/page'));
const OutdoorLightingPage = lazy(() => import('../pages/outdoor/outdoor-lighting/page'));
const OutdoorDecorPage = lazy(() => import('../pages/outdoor/decor/page'));
const EntrywayPage = lazy(() => import('../pages/entryway/page'));
const ConsoleTablesPage = lazy(() => import('../pages/entryway/console-tables/page'));
const CoatRacksPage = lazy(() => import('../pages/entryway/coat-racks/page'));
const EntrywayMirrorsPage = lazy(() => import('../pages/entryway/mirrors/page'));
const EntrywayStoragePage = lazy(() => import('../pages/entryway/storage/page'));
const SofasSectionalsPage = lazy(() => import('../pages/living-room/sofas-sectionals/page'));
const CoffeeTablesPage = lazy(() => import('../pages/living-room/coffee-tables/page'));
const WallArtPage = lazy(() => import('../pages/living-room/wall-art/page'));
const LightingPage = lazy(() => import('../pages/living-room/lighting/page'));
const BedsFramesPage = lazy(() => import('../pages/bedroom/beds-frames/page'));
const NightstandsPage = lazy(() => import('../pages/bedroom/nightstands/page'));
const DressersPage = lazy(() => import('../pages/bedroom/dressers/page'));
const BeddingPage = lazy(() => import('../pages/bedroom/bedding/page'));
const DiningSetsPage = lazy(() => import('../pages/kitchen/dining-sets/page'));
const CookwarePage = lazy(() => import('../pages/kitchen/kitchenware/page'));
const StoragePage = lazy(() => import('../pages/kitchen/storage/page'));
const DecorPage = lazy(() => import('../pages/kitchen/decor/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const ReviewDetailPage = lazy(() => import('../pages/reviews/review-detail-page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:id',
    element: <ArticlePage />,
  },
  {
    path: '/reviews',
    element: <ReviewsPage />,
  },
  {
    path: '/reviews/:slug',
    element: <ReviewDetailPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/room-inspiration',
    element: <RoomInspirationPage />,
  },
  {
    path: '/living-room',
    element: <LivingRoomPage />,
  },
  {
    path: '/living-room/sofas-sectionals',
    element: <SofasSectionalsPage />,
  },
  {
    path: '/living-room/coffee-tables',
    element: <CoffeeTablesPage />,
  },
  {
    path: '/living-room/wall-art',
    element: <WallArtPage />,
  },
  {
    path: '/living-room/lighting',
    element: <LightingPage />,
  },
  {
    path: '/bedroom',
    element: <BedroomPage />,
  },
  {
    path: '/bedroom/beds-frames',
    element: <BedsFramesPage />,
  },
  {
    path: '/bedroom/nightstands',
    element: <NightstandsPage />,
  },
  {
    path: '/bedroom/dressers',
    element: <DressersPage />,
  },
  {
    path: '/bedroom/bedding',
    element: <BeddingPage />,
  },
  {
    path: '/kitchen',
    element: <KitchenPage />,
  },
  {
    path: '/kitchen/dining-sets',
    element: <DiningSetsPage />,
  },
  {
    path: '/kitchen/cookware',
    element: <CookwarePage />,
  },
  {
    path: '/kitchen/kitchenware',
    element: <CookwarePage />,
  },
  {
    path: '/kitchen/storage',
    element: <StoragePage />,
  },
  {
    path: '/kitchen/decor',
    element: <DecorPage />,
  },
  {
    path: '/bathroom',
    element: <BathroomPage />,
  },
  {
    path: '/bathroom/vanities',
    element: <VanitiesPage />,
  },
  {
    path: '/bathroom/mirrors',
    element: <MirrorsPage />,
  },
  {
    path: '/bathroom/storage',
    element: <BathroomStoragePage />,
  },
  {
    path: '/bathroom/accessories',
    element: <AccessoriesPage />,
  },
  {
    path: '/home-office',
    element: <HomeOfficePage />,
  },
  {
    path: '/home-office/desks',
    element: <DesksPage />,
  },
  {
    path: '/home-office/office-chairs',
    element: <OfficeChairsPage />,
  },
  {
    path: '/home-office/storage',
    element: <OfficeStoragePage />,
  },
  {
    path: '/home-office/lighting',
    element: <OfficeLightingPage />,
  },
  {
    path: '/dining-room',
    element: <DiningRoomPage />,
  },
  {
    path: '/dining-room/dining-tables',
    element: <DiningTablesPage />,
  },
  {
    path: '/dining-room/dining-chairs',
    element: <DiningChairsPage />,
  },
  {
    path: '/dining-room/buffets',
    element: <BuffetsPage />,
  },
  {
    path: '/dining-room/lighting',
    element: <DiningLightingPage />,
  },
  {
    path: '/outdoor',
    element: <OutdoorPage />,
  },
  {
    path: '/outdoor/patio-furniture',
    element: <PatioFurniturePage />,
  },
  {
    path: '/outdoor/planters',
    element: <PlantersPage />,
  },
  {
    path: '/outdoor/outdoor-lighting',
    element: <OutdoorLightingPage />,
  },
  {
    path: '/outdoor/decor',
    element: <OutdoorDecorPage />,
  },
  {
    path: '/entryway',
    element: <EntrywayPage />,
  },
  {
    path: '/entryway/console-tables',
    element: <ConsoleTablesPage />,
  },
  {
    path: '/entryway/coat-racks',
    element: <CoatRacksPage />,
  },
  {
    path: '/entryway/mirrors',
    element: <EntrywayMirrorsPage />,
  },
  {
    path: '/entryway/storage',
    element: <EntrywayStoragePage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;